import {
  Container,
  Heading,
  Grid,
  LinkBox,
  LinkOverlay,
  useTheme,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useIsUserInRole } from '@transport-insights/uikit';
import MainLayout from '@src/components/layouts/main';
import { REPORT_LIST } from '@src/modules/regulatory-reporting/shared/constants';

export default function ReportsList() {
  const isDeveloper = useIsUserInRole('Developer');
  const theme = useTheme();
  const enabledReportsList = REPORT_LIST.filter((x) => x.enabled || isDeveloper);

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Heading as="h1">
          Regulatory Reporting
        </Heading>
        <Grid templateColumns={{ md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)', xl: 'repeat(4, 1fr)' }} gap={4} mt={4}>
          {enabledReportsList.map((report) => (
            <LinkBox
              as="article"
              backgroundColor="white"
              p={4}
              borderRadius="md"
              boxShadow="sm"
              key={report.url}
              border="2px solid"
              borderColor="transparent"
              transition="all 200ms"
              _hover={{ borderColor: theme.colors.brand.orange[500] }}
            >
              <Heading size="md" my="2">
                <LinkOverlay
                  as={RouterLink}
                  to={`/regulatory-reporting/reports/${report.url}`}
                  color="gray.800"
                  fontWeight="normal"
                  textDecoration="none"
                >
                  {report.name}
                </LinkOverlay>
              </Heading>
            </LinkBox>
          ))}
        </Grid>
      </Container>
    </MainLayout>
  );
}
